import {
  CalendarIcon,
  DocumentIcon,
  DocumentTextIcon,
  UserGroupIcon,
  UserIcon,
} from "@heroicons/react/20/solid";
import { MentionNode } from "../../Slate/BaseNode";
import { useSelected } from "slate-react";

const mentionStyles: Record<string, string> = {
  user: "text-blue-800 bg-blue-100 dark:bg-blue-900 dark:text-blue-300",
  file: "text-green-800 bg-green-100 dark:bg-green-900 dark:text-green-300",
  event:
    "text-purple-800 bg-purple-100 dark:bg-purple-900 dark:text-purple-300",
  participantId:
    "text-amber-800 bg-amber-100 dark:bg-amber-900 dark:text-amber-300",
  filing: "text-gray-800 bg-gray-100 dark:bg-gray-900 dark:text-gray-300", // Assuming filing uses the same style as file
};

const mentionIcons: Record<string, JSX.Element> = {
  user: <UserIcon className="w-4 h-4 mr-1" />,
  file: <DocumentIcon className="w-4 h-4 mr-1" />,
  event: <CalendarIcon className="w-4 h-4 mr-1" />,
  participantId: <UserGroupIcon className="w-4 h-4 mr-1" />,
  filing: <DocumentTextIcon className="w-4 h-4 mr-1" />, // Assuming filing uses the same icon as file
};

export const MentionElementView: React.FC<{
  element: MentionNode;
  attributes: any;
}> = ({ element, attributes }) => {
  const { mentionType, character } = element;
  const selected = useSelected();

  const baseClass =
    "inline-flex items-center px-2 py-1 text-sm font-medium rounded-full";
  const styleClass =
    mentionStyles[mentionType] ||
    "text-gray-800 bg-gray-100 dark:bg-gray-900 dark:text-gray-300";
  const icon = mentionIcons[mentionType];

  return (
    <span
      {...attributes}
      contentEditable={false}
      className={`${baseClass} ${styleClass} ${selected ? "ring-2 ring-offset-1 ring-blue-500" : ""}`}
      title={`@${character} (${mentionType})`}
    >
      {icon}
      {character}
    </span>
  );
};
